import { Injectable } from '@angular/core';
import { Logger } from './logger';

@Injectable()
export class LoggerService extends Logger {
  invokeConsoleMethod(type: string, args?: any): void { }
}
